<template lang="pug">
  div.labelList-wrapper
    ul.labelList
      li(
        v-for="item in labelList"
        :style="{background: item.color}") {{item.label}}
    ul.labelList-detail
      li(
        v-for="item in labelList")
        div(:style="item|labelStyle") {{item.label}}
        div(
          v-for="child in item.children"
          :style="child|labelStyle") {{child.label}}
</template>

<script>

export default {
  name: 'LabelList',
  props: {
    labelList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    console.log(this.labelList)
    return {}
  },
  filters: {
    labelStyle (child) {
      const borderColor = child.pcolor && child.pcolor !== child.color ? 12 : 0
      return {
        background: child.pcolor || child.color,
        'border-right': `${borderColor}px solid ${child.color}`
      }
    }
  }
}
</script>

<style scoped lang="sass">
.labelList-wrapper
  position: relative
  &:hover
    >ul.labelList-detail
      display: block
ul.labelList
  padding: 10px
  margin: -10px
  text-align: right
  flex: 1
  li
    display: inline-block
    color: #fff
    background: #48b0f7
    font-size: 12px
    width: 80px
    text-align: center
    border-radius: 5px
    margin-left: 5px
    margin-top: 5px
    &:nth-last-of-type(1)
      margin-right: 0
ul.labelList-detail
  display: none
  position: absolute
  top: 0
  right: 0
  z-index: 1000
  text-align: right
  background-color: #FFF
  border: 1px solid #ddd
  padding: 9px
  margin: -10px
  li
    float: left
    color: #fff
    font-size: 12px
    width: 80px
    text-align: center
    margin-right: 5px
    &:nth-last-of-type(1)
      margin-right: 0
    >div
      border-radius: 5px
      margin-top: 5px

</style>



// WEBPACK FOOTER //
// LabelList.vue?7daa636e